import { type AutocompleteOptionWithLabel } from "@pmag/ui-components";
import { type GQLComponentGroupToolbarFragment } from "@src/graphql.generated";

export type ComponentGroupAutocompleteOption = AutocompleteOptionWithLabel & {
    type: string;
};

export function resolveComponentGroupAutocompleteOptions(items: GQLComponentGroupToolbarFragment[]): ComponentGroupAutocompleteOption[] {
    return [...items].map((item) => ({
        label: `${item.code} - ${item.description}`,
        value: item.id,
        type: item.componentType ?? "",
    }));
}
